import {
    DirectoryEntityType,
    DirectoryOtherEstablishmentAddDto,
    DirectoryOtherEstablishmentModifyDto,
    DirectoryOtherEstablishmentSearchDto
} from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { DirectorySearchHelper } from "@/ContactDirectory/Helpers/DirectorySearchHelper";
import { PhoneNumberHelper } from "@/ContactDirectory/Helpers/PhoneNumberHelper";
import { DirectoryOtherEstablishment } from "@/ContactDirectory/Models/DirectoryOtherEstablishment";
import { DirectorySelectableEntity } from "@/ContactDirectory/Models/DirectorySelectableEntity";
import { DirectoryAddressMapper } from "./DirectoryAddressMapper";
import { DirectoryFaxNumberMapper } from "./DirectoryFaxNumberMapper";
import { DirectoryPhoneNumberMapper } from "./DirectoryPhoneNumberMapper";

export class DirectoryOtherEstablishmentMapper {
    public static toModifyDto(establishment: DirectoryOtherEstablishment): DirectoryOtherEstablishmentModifyDto {
        if (!establishment)
            throw new Error("establishment cannot be null.");

        return {
            ...establishment,
            email: !establishment.email?.trim() ? null : establishment.email,
            address: DirectoryAddressMapper.toModifyDto(establishment.address),
            faxNumbers: establishment.faxNumbers.map(p => DirectoryFaxNumberMapper.toDto(p)),
            phoneNumbers: establishment.phoneNumbers.map(p => DirectoryPhoneNumberMapper.toDto(p))
        };
    }

    public static toAddDto(establishment: DirectoryOtherEstablishment): DirectoryOtherEstablishmentAddDto {
        if (!establishment)
            throw new Error("establishment cannot be null.");

        return {
            ...establishment,
            email: !establishment.email?.trim() ? null : establishment.email,
            address: DirectoryAddressMapper.toAddDto(establishment.address),
            faxNumbers: establishment.faxNumbers.map(p => DirectoryFaxNumberMapper.toDto(p)),
            phoneNumbers: establishment.phoneNumbers.map(p => DirectoryPhoneNumberMapper.toDto(p))
        };
    }

    public static toDirectorySelectableEntity(establishment: DirectoryOtherEstablishment): DirectorySelectableEntity<DirectoryOtherEstablishment> {
        if (!establishment)
            return;

        return new DirectorySelectableEntity({
            id: establishment.id,
            type: DirectoryEntityType.Other,
            name: establishment.name,
            address: DirectorySearchHelper.formatAddress(establishment.address),
            phoneNumbers: establishment.phoneNumbers,
            faxInfos: establishment.faxNumbers
                .filter(p => PhoneNumberHelper.validate(p?.number, p?.countryId))
                .map(faxNumber => ({ faxNumber })),
            model: establishment
        });
    }

    public static cloneSearchDto(establishment: DirectoryOtherEstablishmentSearchDto): DirectoryOtherEstablishmentSearchDto {
        return establishment
            ? {
                ...establishment,
                address: establishment.address
                    ? { ...establishment.address }
                    : null,
                faxNumbers: establishment.faxNumbers?.map(p => ({ ...p })),
                phoneNumbers: establishment.phoneNumbers?.map(p => ({ ...p }))
            }
            : null;
    }
}
